import axios from 'axios';

const api = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_AXIOS_BASE_URL! || 'https://admin.chippu.com.br',
});

export { api };
